import { render } from "./mainView.vue?vue&type=template&id=96f241e4&scoped=true"
import script from "./mainView.vue?vue&type=script&lang=js"
export * from "./mainView.vue?vue&type=script&lang=js"

import "./mainView.vue?vue&type=style&index=0&id=96f241e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f241e4"]])

export default __exports__